<script>
import { layoutMethods } from "@/state/helpers";
//import flatPickr from "vue-flatpickr-component";
//import "flatpickr/dist/flatpickr.css";
import { vcRewardsComputed, vcRewardsMethods } from "@/state/helpers"
import Swal from 'sweetalert2';
//import Multiselect from "vue-multiselect";
import moment from 'moment';


/**
 * E-Load list component
 */
export default {
  page: {
    title: "Blvck Coin Rewards"
  },
  data() {
    return {
      searchValue: {
        searchField: null,
        search: "",
        dateRange: null,
        sort: 'id',
        orderDesc: true,
        status: null,
        type: null,
        page: 1,
        rows: 10,
        logShow: false,
      },
      showLogsTitle: "Blvck Coins Giveaway Logs",
      searchList: [
        { text: "Search All", value: null },
        { text: "Name", value: "name" },
        { text: "Business Name", value: "business_name" },
        { text: "Contact Number", value: "mobile_number" },
        { text: "Email Address", value: "email" }
      ],
      rewardLogs: [],
      fields: [
        {
          key: "businessName",
          sortable: true,
        },
        {
          key: "Name",
          sortable: true,
        },
        {
          key: "userEmail",
          sortable: true,
          label: "Email Address"
        },
        {
          key: "userMobileNumber",
          sortable: true,
          label: "Mobile Number"
        },
        {
          key: "action",
          sortable: false,
        },
      ],
      logsfields: [
        {
          key: "created_at",
          sortable: true,
          label: "Date",
        },
        {
          key: "type",
          sortable: true,
        },
        {
          key: "amount",
          sortable: true,
        }
      ],
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      sortBy: "value",
      sortDesc: false,
      rangeOptions: {
        mode: "range",
      },
    };
  },
  components: {
    //flatPickr,
  },
  computed: {
    ...vcRewardsComputed,
    rows() {
      return this.dataList.length;
    },
  },
  mounted() {
    this.changeTitle({title: 'Blvck Coin Rewards'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'BLVCK Coins', to: { name: 'Blvck Coins'}}
      ]
    });
    this.onSearch();
  },
  methods: {
    ...layoutMethods,
    ...vcRewardsMethods,
    convertDate(date) {
      return moment(date).utc().format("LLL");
    },
    async onSearch(state = ''){
        // console.log("onsearch");
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        await this.fetchAllUsers(this.searchValue)
        .then(function(res){
          console.log("check:",res);
        })
        .catch(function(e){
            Swal.fire("Loading Failed!", `${e}`, "error");
        });
    },
  
    async showVCLogs(params)
    {
      console.log(params);
      let self = this;
      await this.fetchUsersVCLogs({dataFilter: "date", businessId: params.id})
        .then(function(res){
          console.log("check:",res);
          self.showLogsTitle = params.title;
          self.logShow = true;
          self.$bvModal.show('bv-modal-vc-logs');
        })
        .catch(function(e){
            Swal.fire("Loading Failed!", `${e}`, "error");
        });
      
      
    },
    hideVCLogs()
    {
      this.$bvModal.hide('bv-modal-vc-logs');
    },
    tableSort(ctx){//context
      this.searchValue.sort = ctx.sortBy;
      this.searchValue.orderDesc = ctx.sortDesc;
      console.log(">> sorting",this.searchValue);
      this.onSearch('reset');
    },
  },
};
</script>

<template>
  <div>
    
    
    <div>

    <b-modal
      id="bv-modal-vc-logs"
      class="mx-auto"
      size="xl"
      centered
      hide-footer
      hide-header-close
    >
    
      <form class="px-4 py-3">
        <h2><span style="color: #C3297C;">{{showLogsTitle}}</span> Blvck Coins Giveaway Logs</h2>
        <div class="mb-3">
          <div class="table-responsive">
            <div class="table align-middle table-nowrap text-capitalize">
              <b-table
                :items="vcRewards"
                :fields="logsfields"
                responsive="sm"
                :sort-desc.sync="sortDesc"
                class="table-check"
              >
                <template #cell(created_at)="data">
                  {{convertDate(data.item.created_at)}}
                </template>
                <template #cell(name)="data">
                  {{data.item.type}}
                </template>
                <template #cell(amount)="data">
                  {{data.item.amount}}
                </template>
              </b-table>
            </div>
          </div>
        </div>
          
        <div class="text-end mt-4">
          <b-button
            variant="light"
            class="w-sm"
            @click="hideVCLogs()"
            >Close</b-button
          >
        </div>
      </form>

    </b-modal>


      
     
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <span class="text-muted fw-normal ms-2">{{userListTotalRows}}</span>
                    Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->
              <div class="col-md-6" style="text-align: right;">
                <!-- <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
                  <i class="uil uil-export me-1"></i>
                  Export
                </a> -->
                <button class="btn btn-secondary" @click="onSearch">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                </button>
              </div>
              <div class="col-md-12 mt-3"></div>
              <!-- Search and button -->
              <div class="col-md-3 ta-right">
                <b-form-group description="Search Keyword">
                  <form class="d-flex" @submit.prevent="onSearch('reset')">
                    <b-form-group id="input-group-3" label-for="input-3">
                      <b-form-select
                        class="form-select rounded-0 rounded-start shadow-none"
                        id="input-3"
                        v-model="searchValue.searchField"
                        :options="searchList"
                      ></b-form-select>
                    </b-form-group>

                    <b-input-group>
                      <b-form-input
                        class="rounded-0"
                        v-model="searchValue.search"
                      ></b-form-input>
                      <b-input-group-append  v-if="false">
                        <b-button
                          variant="primary"
                          type="submit"
                          class="rounded-0 rounded-end px-2"
                        >
                          <i class="bx bx-search bx-fw"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </form>
                </b-form-group>
              </div>
             

              <div class="col-md-4">
                <div
                  class="
                    d-flex
                    flex-wrap
                    align-items-start
                    mt-2 mt-md-0
                    gap-2
                    mb-3 ta-right
                  "
                >
                  <!-- <b-form-group description="Filter by date added">
                    <flat-pickr
                      v-model="searchValue.dateRange"
                      :config="rangeOptions"
                      placeholder="Select a date range"
                      class="form-control"
                      style="width: fit-content"
                    ></flat-pickr>
                  </b-form-group> -->
                  <a class="btn btn-primary h-fit" @click="onSearch('reset')">
                    <i class='bx bx-search bx-fw'></i>Search
                  </a>
                </div>
              </div>
            </div>
            <!-- end col -->
            <!-- end row -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap text-capitalize">
                <b-table
                  :items="userList"
                  :fields="fields"
                  responsive="sm"
                  :current-page="searchValue.page"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="table-check"
                  @sort-changed="tableSort"
                >
                  <template #cell(businessName)="data">
                    {{data.item.businessName}}
                  </template>
                  <template #cell(name)="data">
                    {{data.item.userName}}
                  </template>
                  <template #cell(userEmail)="data">
                    {{data.item.userEmail}}
                  </template>
                  <template #cell(userMobileNumber)="data">
                    {{ data.item.userMobileNumber }}
                  </template>
                  <template #cell(action)="data">
                    <a class="btn btn-secondary" @click="showVCLogs({title: data.item.businessName, id: data.item.businessId})">
                      <i class='bx bxs-book bx-fw' ></i>LOGS
                    </a>
                    <router-link :to="{ name: 'Blvck Coins Add Rewards', params: {id: data.item.businessId,  businessName: data.item.businessName} }" class="tc-white">
                      <a class="mx-2 btn btn-primary">
                        <i class='bx bxs-plus-circle bx-fw'></i>TOP UP
                      </a>
                  </router-link>
                   
                    
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="userListTotalRows == 0">
              <!-- topupLogsTotalRows == 0 -->
              <span>No data to display.</span>
            </div>
            <div class="row" v-if="userListTotalRows > 0">
              <div class="col">
                <div class="form-group row pull-left">
                  <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                  <div class="col-sm-6">
                    <b-form-group label-for="display-record">
                      <b-form-select class="form-select shadow-none w-fit"
                        id="display-record"
                        v-model="searchValue.rows"
                        :options="pageOptions"
                        @change="onSearch('reset')"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                </div>
                <div
                  class="
                    dataTables_paginate
                    paging_simple_numbers
                    float-end
                  "
                >
                  <b-pagination
                    v-if="userListTotalRows != 0 && userListTotalRows > searchValue.rows"
                    class="pagination-rounded"
                    v-model="searchValue.page"
                    :total-rows="userListTotalRows"
                    @input="onSearch()"
                    :per-page="searchValue.rows"
                  ></b-pagination>
                </div>
              </div>
            </div>
            
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
<style>
.custom-checkbox-method label {margin-left: 10px;}
.custom-checkbox-method input {margin-left: 15px;}
.required-input {color:red;}
.calendar-icon {display: block;font-size: 20px;padding: 8px;background-color: grey;}
</style>